<template>

  <b-row v-if="esOftalmo">
    <b-col>
      <b-card
        
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA OFTALMOLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">
            <b-row>
              <b-col>

                <b-form-group class="my-2">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Ha experimentado alguno de los siguientes síntomas? (Seleccione todos los que apliquen)
                  </label>

                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="sintomasOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => oftalmologia.sintomas = onAddNewOpt(newArray)"
                  />

                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleOftalmologiaComienzo">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">¿Cuándo comenzaron sus síntomas?</label>

                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="comienzoOpts"
                    :reduce="option => option"
                    label="text"
                    v-model="oftalmologia.comienzo"
                  />

                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleOftalmologiaFactores">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Factores de riesgo?
                  </label>
                  
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="factoresOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => oftalmologia.factores = onAddNewOpt(newArray)"
                  />
                </b-form-group>
                
                <b-form-group class="my-2" v-if="isVisibleOftalmologiaTratamientos">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Recibe actualmente algun tipo de tratamiento? (Seleccione todos los que apliquen)
                  </label>
                  
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="tratamientoOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => oftalmologia.tratamientos = onAddNewOpt(newArray)"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>


<script>
import { mapState } from "vuex";
import vSelect       from "vue-select";
import { addNewOpt } from '@/shared/helpers';

export default {
  name: "SemiologiaOftalmologica",

  components: {
    vSelect
  },

  data() {
    return {
      visibleBody: true,

      oftalmologia:{
        sintomas:[],
        comienzo:null,
        factores:[],
        tratamientos:[],
      },

      isVisibleOftalmologiaComienzo:false,
      isVisibleOftalmologiaFactores:false,
      isVisibleOftalmologiaTratamientos:false,

      sintomasOpts : [
        { value: 'vision_borrosa',                 text: 'Visión borrosa' },
        { value: 'perdida_vision',                 text: 'Pérdida de visión' },
        { value: 'dolor_ocular',                   text: 'Dolor ocular' },
        { value: 'enrojecimiento_ojos',            text: 'Enrojecimiento de los ojos' },
        { value: 'lagrimeo_excesivo',              text: 'Lagrimeo excesivo' },
        { value: 'sensibilidad_luz',               text: 'Sensibilidad a la luz (fotofobia)' },
        { value: 'vision_destellos',               text: 'Visión de destellos o luces' },
        { value: 'picazon_en_los_ojos',            text: 'Picazón en los ojos' },
        { value: 'secrecion_ocular',               text: 'Secreción ocular' },
        { value: 'ojos_secos',                     text: 'Ojos secos' },
        { value: 'vision_doble',                   text: 'Visión doble (diplopía)' },
        { value: 'cambios_vision_color',           text: 'Cambios en la visión del color' },
        { value: 'vision_de_manchas_o_flotadores', text: 'Visión de manchas o flotadores' },
        { value: 'dificultad_para_ver_de_noche',   text: 'Dificultad para ver de noche' },
      ],

      comienzoOpts:[
        { value: 'dias',    text: 'días' },
        { value: 'semanas', text: 'semanas' },
        { value: 'meses',   text: 'meses' },
        { value: 'anios',   text: 'años' }
      ],

      factoresOpts:[
        { value: 'uso_pantallas',             text: 'Uso prolongado de pantallas (computadora, teléfono, etc.)' },
        { value: 'exposicion_uv',             text: 'Exposición a radiación UV' },
        { value: 'tabaquismo',                text: 'Tabaquismo' },
        { value: 'diabetes',                  text: 'Diabetes' },
        { value: 'hipertension',              text: 'Hipertensión' },
        { value: 'exceso_alcohol',            text: 'Consumo excesivo de alcohol' },
        { value: 'usoLentes_contacto',        text: 'Uso de lentes de contacto' },
        { value: 'cirugias_oculares_previas', text: 'Cirugías oculares previas' }
      ],

      tratamientoOpts : [
        { value: 'gotas_para_ojos',     text: 'Gotas para ojos' },
        { value: 'medicamentos_orales', text: 'Medicamentos orales' },
        { value: 'terapia_laser',       text: 'Terapia láser' },
        { value: 'cirugia',             text: 'Cirugía' }
      ]

    };
  },

  methods: {
    onVisibleBody(newValue) {
      this.visibleBody = newValue;
    },

    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },

  computed:{
    ...mapState({
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esOftalmo(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000135';
    },

  },

  watch: {
    oftalmologia: {
      handler(newValue) {
        this.isVisibleOftalmologiaComienzo     = newValue.sintomas.length > 0;
        this.isVisibleOftalmologiaFactores     = newValue.comienzo && this.isVisibleOftalmologiaComienzo;
        this.isVisibleOftalmologiaTratamientos = newValue.factores.length > 0 && this.isVisibleOftalmologiaFactores;
      },
      deep: true
    }
  },

}
</script>